<div class="users-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">{{ isCreateRoute() ? 'CREAR USUARIO' : 'USUARIOS' }}</h1>
                <p class="page-subtitle text-muted" *ngIf="!isCreateRoute()">
                    Gestione usuarios: cree, edite, asigne roles y controle estados de actividad
                </p>
            </div>
            <div class="header-actions">
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="onCreateUser()"
                    matTooltip="Crear nuevo usuario">
                    <mat-icon>person_add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div class="filter-row">
                <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
                    <mat-label>Buscar usuario</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input
                        matInput
                        type="text"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="applyFilter()"
                        placeholder="Nombre o email..."
                        inputmode="search"
                        autocomplete="off" />
                    <button mat-icon-button matSuffix type="button" *ngIf="searchTerm" (click)="searchTerm = ''; applyFilter()" matTooltip="Limpiar búsqueda" aria-label="Limpiar búsqueda">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="users-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>

                        <!-- Usuario Column -->
                        <ng-container matColumnDef="user">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                                Usuario
                            </th>
                            <td mat-cell *matCellDef="let element" class="pl-0">
                                <div class="user-info">
                                    <h6 class="mt-0 mb-0">{{element.name}}</h6>
                                    <span class="text-body">{{element.email}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Rol Column -->
                        <ng-container matColumnDef="role">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Rol
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.role === 'admin'">
                                    Administrador
                                </span>
                                <span class="trinta-badge fw-medium onHand d-inline-block" *ngIf="element.role === 'operator'">
                                    Operador
                                </span>
                                <span class="trinta-badge fw-medium urgent d-inline-block" *ngIf="element.role === 'client'">
                                    Cliente
                                </span>
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.role === 'consignatario'">
                                    Consignatario
                                </span>
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.role === 'transportista'">
                                    Transportista
                                </span>
                            </td>
                        </ng-container>

                        <!-- Estado Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Estado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.status === 'active'">
                                    Activo
                                </span>
                                <span class="trinta-badge fw-medium onHand d-inline-block" *ngIf="element.status === 'inactive'">
                                    Inactivo
                                </span>
                            </td>
                        </ng-container>

                        <!-- Teléfono Column -->
                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Teléfono
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.phone}}
                            </td>
                        </ng-container>

                        <!-- Fecha de Registro Column -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Fecha de Registro
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.createdAt}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                            <td mat-cell *matCellDef="let element" class="text-end pr-0">
                                <div class="action">
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="editUser(element)">
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="deleteUser(element)">
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>